































































import { Component, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  BookbindingCollectionInfo,
  BookbindingCollectionInfoItem,
  defaultBookbindingCollectionInfoItem
} from '@/components/organisms/BookbindingCollectionInfo'
import {
  BookbindingCollectionTable,
  BookbindingCollectionTableItem,
  defaultBookbindingCollectionTableItem
} from '@/components/organisms/BookbindingCollectionTable'
import {
  alertStore,
  modalBibliographyDetailRealStore,
  modalBibliographySearchStore,
  modalErrorStore,
  systemParameterStore
} from '@/utils/store-accessor'
import CODE_KEY from '@/config/code_key'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import {
  Alert,
  AlertMessage,
  BibliographySearchResultItem,
  BookbindingCollection,
  BookbindingTargetCollection,
  collectionApi,
  ErrorMessage,
  SimpleCollection
} from '@/api'
import {
  AlertCodeALC00002,
  AlertCodeILC00031,
  AlertCodeTL300082,
  AlertCodeTL700020,
  AuthoritySearchType,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullId,
  BibliographyFullIdWithMarcNo,
  Prefix
} from '@/types'
import { AlertFactory } from '@/factory'
import { SelectBibliographyDetailReal } from '@/store/ModalBibliographyDetailRealStore'
import { BibliographyIntegrationSearchConditions } from '@/components/organisms/BibliographyIntegrationSearchConditions'

interface ModalBookbindingInterface {
  collectionIds: number[]
}

@Component({
  components: {
    BibliographyIntegrationSearchConditions,
    BookbindingCollectionTable,
    BookbindingCollectionInfo,
    ModalFooter
  }
})
export default class ModalBookbinding extends ComponentVue {
  @Ref()
  bookbindingCollectionInfo!: BookbindingCollectionInfo

  @Ref()
  bookbindingCollectionTable!: BookbindingCollectionTable

  dialog: boolean = false

  tableBodyHeight: number = 0

  collectionIds: number[] = []

  infoItem: BookbindingCollectionInfoItem = defaultBookbindingCollectionInfoItem()

  tableItem: BookbindingCollectionTableItem = defaultBookbindingCollectionTableItem()

  isSearchedBookbindingCollection: boolean = false

  get disabledRegistrationButton(): boolean {
    return (
      this.tableItem.collections.length === 0 ||
      !this.isSearchedBookbindingCollection
    )
  }

  get existsCollectionIds(): boolean {
    return this.collectionIds.length > 0
  }

  get isHitOneSearchResults(): boolean {
    return modalBibliographySearchStore.total === 1
  }

  get searchResults(): BibliographySearchResultItem[] {
    return modalBibliographySearchStore.items
  }

  open(params?: ModalBookbindingInterface): void {
    this.dialog = true
    if (params) {
      this.collectionIds = params.collectionIds
      this.getBookbindingTargetCollections()
    }
    systemParameterStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.NUMBER_MANAGEMENT.KEY // 資料番号入力で使用
    ])
    window.addEventListener('resize', this.calculateTableHeight)
    this.$nextTick(() => {
      this.calculateTableHeight()
      setTimeout(this.bookbindingCollectionInfo.focusCollectionNo)
    })
  }

  close(): void {
    this.dialog = false
    this.infoItem = defaultBookbindingCollectionInfoItem()
    this.tableItem = defaultBookbindingCollectionTableItem()
    this.isSearchedBookbindingCollection = false
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      const modalElements: HTMLCollection | null = document.getElementsByClassName(
        'v-dialog--active'
      ) as HTMLCollectionOf<HTMLElement>

      this.tableBodyHeight =
        window.innerHeight -
        (modalElements[modalElements.length - 1]?.clientHeight + 48)
    })
  }

  onClickCancel(): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: this.close
    })
  }

  initialize(): void {
    this.clearData()
    this.$nextTick(this.bookbindingCollectionInfo.focusCollectionNo)
  }

  initializeTableCollectionNo(): void {
    this.tableItem.collectionNo.input = ''
    this.bookbindingCollectionTable.focusCollectionNo()
  }

  clearData(): void {
    this.infoItem = defaultBookbindingCollectionInfoItem()
    this.tableItem = defaultBookbindingCollectionTableItem()
    this.isSearchedBookbindingCollection = false
  }

  onClickTitle(bibliographyFullId: BibliographyFullId): void {
    this.openModalBibliographyDetail(
      false,
      bibliographyFullId.prefix,
      bibliographyFullId.id,
      () => {}
    )
  }

  print() {
    const element = document.querySelector('#modal-bookbinding')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  checkTableCollectionNoCheck(): void {
    if (document.activeElement !== null) {
      ;(document.activeElement as any).blur()
    }

    const alerts: Alert[] = []

    if (
      this.tableItem.collectionNo.input === this.infoItem.collectionNo.input
    ) {
      alerts.push(AlertFactory.create(AlertCodeTL300082))
    }

    if (
      this.tableItem.collections.some(
        collection =>
          this.tableItem.collectionNo.input === collection.collectionNo
      )
    ) {
      alerts.push(AlertFactory.create(AlertCodeILC00031, '資料番号'))
    }

    if (alerts.length > 0) {
      alertStore.setItems(alerts)
      this.tableItem.collectionNo.errorMessage = alerts[0].message
      this.$modalAlert.open({
        onOkClick: this.initializeTableCollectionNo
      })
      return
    }

    this.getBookbindingTargetCollections()
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  async getBookbindingCollection(collectionId: number = 0): Promise<void> {
    if (document.activeElement !== null) {
      ;(document.activeElement as any).blur()
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const collection: BookbindingCollection = await collectionApi.getBookbindingCollection(
        {
          collectionId,
          collectionNo:
            collectionId === 0 ? this.infoItem.collectionNo.input : ''
        }
      )
      this.infoItem = {
        collectionId: collection.collectionId,
        collectionNo: {
          input: collection.collectionNo,
          errorMessage: ''
        },
        bibliographyClass: collection.bibliographyClass,
        prefix: collection.prefix,
        bibliographyId: collection.bibliographyId,
        searchType: collection.searchType,
        displayTitle: collection.displayTitle,
        displayAuthor: collection.displayAuthor,
        displayPublisher: collection.displayPublisher,
        volume: collection.volume,
        volumeNumber: collection.volumeNumber,
        volumeTotal: collection.volumeTotal,
        volumeDateLabel: collection.volumeDateLabel,
        volumeSpecial: collection.volumeSpecial,
        collectionFlag: collection.collectionFlag,
        revision: collection.revision
      }
      this.isSearchedBookbindingCollection = true

      await this.getBookBoundCollection()

      // 選択処理が終了した段階で資料関連ダイアログを閉じる
      modalBibliographyDetailRealStore.close()

      this.$nextTick(this.bookbindingCollectionTable.focusCollectionNo)
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeTL700020
        ) {
          await this.getSimpleCollection()
          return
        }
        this.setErrorMessage(error.alerts, {
          collectionNo: this.infoItem.collectionNo
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          onOkClick: () => {
            this.infoItem.collectionNo.input = ''
            this.bookbindingCollectionInfo.focusCollectionNo()
          }
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getBookBoundCollection(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const responses: BookbindingTargetCollection[] = await collectionApi.getBookBoundCollections(
        {
          collectionId: this.infoItem.collectionId
        }
      )
      this.tableItem.collections.push(
        ...responses.map(collection => {
          return {
            collectionId: collection.collectionId,
            collectionNo: collection.collectionNo,
            parentCollectionId: collection.parentCollectionId,
            holdingBranchCode: {
              input: collection.holdingBranchCode.code,
              errorMessage: ''
            },
            shelfType: collection.shelfType,
            collectionType: {
              input: collection.collectionType.code,
              errorMessage: ''
            },
            handlingType: {
              input: collection.handlingType.code,
              errorMessage: ''
            },
            revision: collection.revision,
            bibliographyClass: collection.bibliographyClass,
            prefix: collection.prefix,
            bibliographyId: collection.bibliographyId,
            searchType: collection.searchType,
            displayTitle: collection.displayTitle,
            sortTitle: collection.sortTitle,
            displayAuthor: collection.displayAuthor,
            sortAuthor: collection.sortAuthor,
            displayPublisher: collection.displayPublisher,
            collectionFlag: collection.collectionFlag,
            _remove: {
              input: false
            }
          }
        })
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getBookbindingTargetCollections(
    collectionId: number = 0
  ): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const responses: BookbindingTargetCollection[] = await collectionApi.getBookbindingTargetCollections(
        {
          collectionId,
          collectionIds: this.collectionIds,
          collectionNo:
            collectionId === 0 ? this.tableItem.collectionNo.input : ''
        }
      )

      this.tableItem.collections.unshift(
        ...responses.map(collection => {
          return {
            collectionId: collection.collectionId,
            collectionNo: collection.collectionNo,
            parentCollectionId: collection.parentCollectionId,
            holdingBranchCode: {
              input: collection.holdingBranchCode.code,
              errorMessage: ''
            },
            shelfType: collection.shelfType,
            collectionType: {
              input: collection.collectionType.code,
              errorMessage: ''
            },
            handlingType: {
              input: collection.handlingType.code,
              errorMessage: ''
            },
            revision: collection.revision,
            bibliographyClass: collection.bibliographyClass,
            prefix: collection.prefix,
            bibliographyId: collection.bibliographyId,
            searchType: collection.searchType,
            displayTitle: collection.displayTitle,
            sortTitle: collection.sortTitle,
            displayAuthor: collection.displayAuthor,
            sortAuthor: collection.sortAuthor,
            displayPublisher: collection.displayPublisher,
            collectionFlag: collection.collectionFlag,
            _remove: {
              input: false
            }
          }
        })
      )

      this.initializeTableCollectionNo()

      // 選択処理が終了した段階で資料関連ダイアログを閉じる
      modalBibliographyDetailRealStore.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeTL700020
        ) {
          await this.getSimpleCollection()
          return
        }
        this.setErrorMessage(error.alerts, {
          collectionNo: this.tableItem.collectionNo
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          onOkClick: this.initializeTableCollectionNo
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async bookbindingCollections(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await collectionApi.bookbindingCollections({
        parentCollectionId: this.infoItem.collectionId,
        revision: this.infoItem.revision,
        collections: this.tableItem.collections.map(item => {
          return {
            id: item.collectionId,
            holdingBranchCode: item.holdingBranchCode.input,
            collectionType: item.collectionType.input,
            handlingType: item.handlingType.input,
            revision: item.revision,
            _remove: item._remove.input
          }
        })
      })

      if (this.existsCollectionIds) {
        this.tableItem = defaultBookbindingCollectionTableItem()
        await this.getBookBoundCollection()
        this.$nextTick(this.bookbindingCollectionInfo.focusCollectionNo)
      } else {
        this.initialize()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.tableItem)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getSimpleCollection(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const collectionNo: string = this.isSearchedBookbindingCollection
        ? this.tableItem.collectionNo.input
        : this.infoItem.collectionNo.input

      const collections: SimpleCollection[] = await collectionApi.getSimpleCollections(
        {
          collectionNo
        }
      )

      this.$modalCollectionSelect.open({
        collectionNo,
        simpleCollections: collections,
        onClickOk: (id: number) => {
          if (this.isSearchedBookbindingCollection) {
            this.getBookbindingTargetCollections(id)
          } else {
            this.getBookbindingCollection(id)
          }
        }
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // ここから資料検索ダイアログ、資料検索結果ダイアログ、資料照会ダイアログの制御記述
  openModalBibliographySearchCondition(isBack: boolean = false): void {
    this.$modalBibliographySearchCondition.open({
      isBack,
      onSearch: () => {
        if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0].bibliographyId,
            this.openModalBibliographySearchResult
          )
          return
        }
        this.openModalBibliographySearchResult()
      },
      onSearchAuthority: () => {
        if (
          modalBibliographySearchStore.authoritySearchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          if (modalBibliographySearchStore.contentItems.length === 1) {
            this.openModalBibliographyDetail(
              true,
              modalBibliographySearchStore.contentItems[0].prefix,
              modalBibliographySearchStore.contentItems[0]?.bibliographyId ?? 0,
              this.openModalBibliographySearchResultContent,
              '',
              modalBibliographySearchStore.contentItems[0]
                ?.bibliographyContentId ?? 0
            )
          } else if (modalBibliographySearchStore.authorityItems.length === 1) {
            this.openModalBibliographySearchResultContent()
          } else {
            this.openModalBibliographySearchResultAuthority()
          }
        } else if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0].bibliographyId,
            this.openModalBibliographySearchResult
          )
        } else if (modalBibliographySearchStore.authorityItems.length === 1) {
          this.openModalBibliographySearchResult()
        } else {
          this.openModalBibliographySearchResultAuthority()
        }
      },
      onSearchContent: () => {
        if (modalBibliographySearchStore.contentItems.length === 1) {
          this.openModalBibliographyDetail(
            true,
            modalBibliographySearchStore.contentItems[0].prefix,
            modalBibliographySearchStore.contentItems[0].bibliographyId,
            this.openModalBibliographySearchResultContent,
            '',
            modalBibliographySearchStore.contentItems[0]
              ?.bibliographyContentId ?? 0
          )
        } else {
          this.openModalBibliographySearchResultContent()
        }
      }
    })
  }

  openModalBibliographySearchResult(onBackResult?: () => void) {
    this.$modalBibliographySearchResult.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onTitle: (bibliographyFullIdWithMarcNo: BibliographyFullIdWithMarcNo) => {
        this.openModalBibliographyDetail(
          true,
          bibliographyFullIdWithMarcNo.prefix,
          bibliographyFullIdWithMarcNo.id ?? 0,
          () => {
            this.openModalBibliographySearchResult(onBackResult)
          }
        )
      }
    })
  }

  openModalBibliographySearchResultAuthority(): void {
    this.$modalBibliographySearchResultAuthority.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onSearch: () => {
        if (
          modalBibliographySearchStore.authoritySearchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          if (modalBibliographySearchStore.contentItems.length === 1) {
            this.openModalBibliographyDetail(
              true,
              modalBibliographySearchStore.contentItems[0].prefix,
              modalBibliographySearchStore.contentItems[0]?.bibliographyId ?? 0,
              this.openModalBibliographySearchResultAuthority
            )
          } else {
            this.openModalBibliographySearchResultContent()
          }
        } else if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0]?.bibliographyId ?? 0,
            this.openModalBibliographySearchResultAuthority
          )
        } else {
          this.openModalBibliographySearchResult(
            this.openModalBibliographySearchResultAuthority
          )
        }
      }
    })
  }

  openModalBibliographySearchResultContent(): void {
    this.$modalBibliographySearchResultContent.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult: this.openModalBibliographySearchResultAuthority,
      onSelectContent: (
        prefix: Prefix,
        bibliographyRealId: number,
        bibliographyContentId: number
      ) => {
        this.openModalBibliographyDetail(
          true,
          prefix,
          bibliographyRealId,
          this.openModalBibliographySearchResultContent,
          '',
          bibliographyContentId
        )
      }
    })
  }

  openModalBibliographyDetail(
    isCollectionSelect: boolean,
    prefix: Prefix,
    bibliographyId: number,
    onBackResult: () => void,
    marcNo?: string,
    bibliographyContentId?: number
  ): void {
    if (prefix === Prefix.Real) {
      this.openModalBibliographyDetailReal(
        isCollectionSelect,
        bibliographyId,
        modalBibliographySearchStore.contentItems.length > 0
          ? BibliographyDetailRealTabType.Content
          : BibliographyDetailRealTabType.Collection,
        onBackResult,
        marcNo,
        bibliographyContentId
      )
      return
    }
    this.openModalBibliographyDetailSet(
      isCollectionSelect,
      bibliographyId,
      BibliographyDetailSetTabType.Volume,
      onBackResult
    )
  }

  openModalBibliographyDetailReal(
    isCollectionSelect: boolean,
    bibliographyRealId: number,
    tabType: BibliographyDetailRealTabType,
    onBackResult: () => void,
    marcNo?: string,
    bibliographyContentId?: number
  ): void {
    this.$modalBibliographyDetailReal.open({
      isCollectionSelect,
      bibliographyRealId,
      marcNo,
      tabType,
      bibliographyContentId,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onSelect: (value: SelectBibliographyDetailReal) => {
        if (this.isSearchedBookbindingCollection) {
          this.tableItem.collectionNo.input = value.collectionNo
        } else {
          this.infoItem.collectionNo.input = value.collectionNo
        }
      },
      onToggleSet: (
        bibliographyId: number,
        tabType: BibliographyDetailSetTabType
      ) => {
        this.openModalBibliographyDetailSet(
          true,
          bibliographyId,
          tabType,
          onBackResult
        )
      }
    })
  }

  openModalBibliographyDetailSet(
    isBibliographySelectProcess: boolean,
    bibliographySetId: number,
    tabType: BibliographyDetailSetTabType,
    onBackResult: () => void
  ): void {
    this.$modalBibliographyDetailSet.open({
      disabledSelect: true,
      isBibliographySelectProcess,
      bibliographySetId,
      tabType,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onToggleReal: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailReal(
          isBibliographySelectProcess,
          bibliographyId,
          tabType,
          onBackResult
        )
      }
    })
  }
}
